(function() {
  const swiper_Sections = document.querySelectorAll('[data-swiper_id^="swiper__controls_"]');
     
  if (swiper_Sections) {
    
      function convertBooleanToNumber(value) {
        return value === "true" ? 1 : 0;
      }

    swiper_Sections.forEach(swiper_Section => {
      const swiperId = swiper_Section.dataset.swiper_id;
      const slide_count = parseFloat(swiper_Section.dataset.slidedesktop);
      const slide_count_tab = parseFloat(swiper_Section.dataset.slidetab);
      const slide_count_mobile = parseFloat(swiper_Section.dataset.slidemobile);
      
      const swiper = new Swiper(`[data-swiper_id="${swiperId}"] .swiper__Container`, {
        loop: false,
        watchSlidesProgress: true,
        grabCursor: true,
        centeredSlides: true,
        navigation: {
          nextEl: `[data-swiper_id="${swiperId}"] .swiper-button-next`,
          prevEl: `[data-swiper_id="${swiperId}"] .swiper-button-prev`,
        },
        slidesPerView: slide_count_mobile,
        spaceBetween: 10,
        breakpoints: {
          600: {
            loop: false,
            slidesPerView: slide_count_tab,
            centeredSlides: false,
            spaceBetween: 10,
          },
          768: {
            loop: false,
            slidesPerView: slide_count_tab,
            centeredSlides: false,
            spaceBetween: 10,
          },
          1326: {
            loop: false,
            slidesPerView: slide_count,
            centeredSlides: false,
            spaceBetween: 10,
          },
        },
      });
    });
  }
})();